module.exports = __webpack_public_path__ + "static/img/10007.eddfd025.png";